'use strict';

const ExcelJS = require('exceljs');

async function createExcel(data) {
    const { basketModel, resources } = data;
    const now = new Date();
    const date = now.toISOString().slice(0, 10);
    const time = now.toTimeString().slice(0, 5);

    try {
        const excelData = [
            [resources.shareTitle],
            [resources.companyName]
        ];

        if (resources.companyAddressline1) {
            excelData.push([resources.companyAddressline1]);
        }
        if (resources.companyAddressline2) {
            excelData.push([resources.companyAddressline2]);
        }
        if (resources.companyState) {
            excelData.push([resources.companyState]);
        }
        if (resources.companyPostcode) {
            excelData.push([resources.companyPostcode]);
        }
        if (resources.companyCity) {
            excelData.push([resources.companyCity]);
        }
        if (resources.companyCountry) {
            excelData.push([resources.companyCountry]);
        }
        if (resources.companyPhone) {
            excelData.push([`${resources.shareTelephoneNumber} ${resources.companyPhone}`]);
        }

        excelData.push(
            [],
            [`${resources.shareCreationDate} ${date} ${time}`]
        );
        const creationDateRow = excelData.length;

        excelData.push(
            [],
            [resources.sharePriceDisclaimerText],
            [],
            [],
            [resources.shareQuantity, resources.shareSku, resources.shareItems, resources.shareItemPrice, resources.shareItemTotal]
        );

        const headerRow = excelData.length;
        basketModel.items.forEach(item => {
            excelData.push([
                item.quantity,
                item.id,
                item.productName,
                item.unitPrice,
                item.totalPrice
            ]);
        });

        const totalRow = excelData.length + 1;
        excelData.push(['', '', '', '', basketModel.totals.grandTotal]);
        excelData.push([]);
        excelData.push([]);
        excelData.push([`${resources.shareMoreInfo} ${resources.companyWebsite}`]);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Shopping Cart', {
            views: [{ showGridLines: false }]
        });

        excelData.forEach(row => {
            worksheet.addRow(row);
        });

        const thin = { style: 'thin', color: { argb: 'FF000000' } };
        const bold = { style: 'medium', color: { argb: 'FF000000' } };

        const getAlignment = (col) => {
            if (col === 1 || col === 2) {
                return { horizontal: 'center' };
            }
            if (col === 4 || col === 5) {
                return { horizontal: 'right' };
            }
            return { horizontal: 'left' };
        };

        worksheet.getRow(1).getCell(1).font = { bold: true };
        worksheet.getRow(creationDateRow).getCell(1).font = { bold: true };

        [1, 2, 3, 4, 5].forEach(col => {
            const cell = worksheet.getRow(headerRow).getCell(col);
            cell.font = { bold: true };
            cell.alignment = getAlignment(col);
            cell.border = {
                bottom: bold,
                left: thin,
                right: col === 4 ? bold : (col === 5 ? null : thin)
            };
        });

        for (let row = headerRow + 1; row < totalRow; row++) {
            [1, 2, 3, 4, 5].forEach(col => {
                const cell = worksheet.getRow(row).getCell(col);
                cell.font = { bold: col === 5 };
                cell.alignment = getAlignment(col);
                cell.border = {
                    top: thin,
                    bottom: thin,
                    left: thin,
                    right: col === 4 ? bold : (col === 5 ? null : thin)
                };
            });
        }

        worksheet.getRow(totalRow).getCell(4).border = { right: bold };
        const totalCell = worksheet.getRow(totalRow).getCell(5);
        totalCell.font = { bold: true };
        totalCell.alignment = { horizontal: 'right' };
        totalCell.border = { top: thin, bottom: bold, left: thin };

        const linkRow = worksheet.getRow(excelData.length).getCell(1);
        const websiteUrl = resources.companyWebsite.startsWith('http')
            ? resources.companyWebsite
            : `https://${resources.companyWebsite}`;
        linkRow.value = {
            text: `${resources.shareMoreInfo} ${resources.companyWebsite}`,
            hyperlink: websiteUrl
        };

        worksheet.getColumn(1).width = 10;
        worksheet.getColumn(2).width = 12;
        worksheet.getColumn(3).width = 72;
        worksheet.getColumn(4).width = 15;
        worksheet.getColumn(5).width = 15;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Cart_${resources.siteId}_${date}_${time}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);

        return {
            success: true,
            error: false,
            msg: data?.resources.shareSuccess,
            showMsg: true
        };
    } catch (error) {
        return {
            success: false,
            error: true,
            msg: data?.resources.shareError || 'Error creating Excel',
            showMsg: true
        };
    }
}

module.exports = createExcel;
